export const TEXT_COLOR_CLASS = {
  white: "text-white",
  secondary: "text-secondary",
  "secondary-100": "text-secondary-100",
  primary: "text-primary",
  "greyscale-headline": "text-greyscale-headline",
} as const;

export type HealthHeroTextColor = keyof typeof TEXT_COLOR_CLASS;

export const TEXT_ALIGN_CLASS = {
  left: "text-left items-start",
  center: "text-center items-center",
  right: "text-right items-end",
} as const;

export type HealthHeroTextAlign = keyof typeof TEXT_ALIGN_CLASS;

export const OVERLAY_CLASS = {
  none: "",
  light: "bg-black/25",
  medium: "bg-black/45",
  dark: "bg-black/65",
} as const;

export type HealthHeroOverlay = keyof typeof OVERLAY_CLASS;

export function textColorClass(value: string | null | undefined): string {
  if (value && value in TEXT_COLOR_CLASS) {
    return TEXT_COLOR_CLASS[value as HealthHeroTextColor];
  }
  return TEXT_COLOR_CLASS.white;
}

export function textAlignClass(value: string | null | undefined): string {
  if (value && value in TEXT_ALIGN_CLASS) {
    return TEXT_ALIGN_CLASS[value as HealthHeroTextAlign];
  }
  return TEXT_ALIGN_CLASS.center;
}

export function overlayClass(value: string | null | undefined): string {
  if (value && value in OVERLAY_CLASS) {
    return OVERLAY_CLASS[value as HealthHeroOverlay];
  }
  return OVERLAY_CLASS.medium;
}
